import React from 'react';

const Input = ({...props}) => {
  return (
      <input className="input" {...props} />
  );
};

export default Input;
